package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ExplosionW500Rounded: ImageVector
    get() {
        if (_explosionW500Rounded != null) {
            return _explosionW500Rounded!!
        }
        _explosionW500Rounded = Builder(name = "ExplosionW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(422.43f, 616.41f)
                lineToRelative(31.0f, 30.24f)
                quadToRelative(11.29f, 11.28f, 26.57f, 11.28f)
                quadToRelative(15.28f, 0.0f, 26.57f, -11.28f)
                lineToRelative(31.0f, -30.24f)
                horizontalLineToRelative(41.23f)
                quadToRelative(16.05f, 0.0f, 26.95f, -10.9f)
                quadToRelative(10.9f, -10.9f, 10.9f, -26.94f)
                verticalLineToRelative(-41.0f)
                lineToRelative(30.24f, -31.0f)
                quadToRelative(11.28f, -11.29f, 11.28f, -26.57f)
                quadToRelative(0.0f, -15.28f, -11.28f, -26.57f)
                lineToRelative(-30.24f, -31.0f)
                verticalLineToRelative(-41.23f)
                quadToRelative(0.0f, -16.05f, -10.9f, -26.95f)
                quadToRelative(-10.9f, -10.9f, -26.95f, -10.9f)
                horizontalLineToRelative(-41.23f)
                lineToRelative(-36.33f, -35.57f)
                quadToRelative(-9.0f, -9.0f, -21.24f, -9.0f)
                quadToRelative(-12.24f, 0.0f, -21.24f, 9.0f)
                lineToRelative(-36.33f, 35.57f)
                horizontalLineToRelative(-41.0f)
                quadToRelative(-16.04f, 0.0f, -26.94f, 10.9f)
                quadToRelative(-10.9f, 10.9f, -10.9f, 26.95f)
                verticalLineToRelative(41.23f)
                lineToRelative(-30.24f, 31.0f)
                quadToRelative(-11.28f, 11.29f, -11.28f, 26.57f)
                quadToRelative(0.0f, 15.28f, 11.28f, 26.57f)
                lineToRelative(30.24f, 31.0f)
                verticalLineToRelative(41.0f)
                quadToRelative(0.0f, 16.04f, 11.02f, 26.94f)
                quadToRelative(11.02f, 10.9f, 27.06f, 10.9f)
                horizontalLineToRelative(40.76f)
                close()
                moveTo(344.8f, 808.13f)
                lineTo(242.87f, 808.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                lineTo(151.87f, 615.2f)
                lineToRelative(-70.54f, -71.55f)
                quadToRelative(-12.68f, -13.43f, -19.4f, -29.97f)
                quadToRelative(-6.71f, -16.53f, -6.71f, -33.68f)
                reflectiveQuadToRelative(6.71f, -33.68f)
                quadToRelative(6.72f, -16.54f, 19.4f, -29.97f)
                lineToRelative(70.54f, -71.55f)
                verticalLineToRelative(-101.93f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                lineTo(344.8f, 151.87f)
                lineToRelative(71.55f, -70.54f)
                quadToRelative(13.67f, -12.68f, 30.08f, -19.4f)
                quadToRelative(16.42f, -6.71f, 33.57f, -6.71f)
                reflectiveQuadToRelative(33.57f, 6.71f)
                quadToRelative(16.41f, 6.72f, 30.08f, 19.4f)
                lineToRelative(71.55f, 70.54f)
                horizontalLineToRelative(101.93f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(101.93f)
                lineToRelative(70.54f, 71.55f)
                quadToRelative(12.68f, 13.67f, 19.4f, 30.08f)
                quadToRelative(6.71f, 16.42f, 6.71f, 33.57f)
                reflectiveQuadToRelative(-6.71f, 33.57f)
                quadToRelative(-6.72f, 16.41f, -19.4f, 30.08f)
                lineToRelative(-70.54f, 71.55f)
                verticalLineToRelative(101.93f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(615.2f, 808.13f)
                lineToRelative(-71.55f, 70.54f)
                quadToRelative(-13.43f, 12.68f, -29.97f, 19.4f)
                quadToRelative(-16.53f, 6.71f, -33.68f, 6.71f)
                reflectiveQuadToRelative(-33.68f, -6.71f)
                quadToRelative(-16.54f, -6.72f, -29.97f, -19.4f)
                lineToRelative(-71.55f, -70.54f)
                close()
                moveTo(383.35f, 717.13f)
                lineTo(480.0f, 813.78f)
                lineToRelative(96.65f, -96.65f)
                horizontalLineToRelative(140.48f)
                verticalLineToRelative(-140.48f)
                lineTo(813.78f, 480.0f)
                lineToRelative(-96.65f, -96.65f)
                verticalLineToRelative(-140.48f)
                lineTo(576.65f, 242.87f)
                lineTo(480.0f, 146.22f)
                lineToRelative(-96.65f, 96.65f)
                lineTo(242.87f, 242.87f)
                verticalLineToRelative(140.48f)
                lineTo(146.22f, 480.0f)
                lineToRelative(96.65f, 96.65f)
                verticalLineToRelative(140.48f)
                horizontalLineToRelative(140.48f)
                close()
                moveTo(480.0f, 480.0f)
                close()
            }
        }
        .build()
        return _explosionW500Rounded!!
    }

private var _explosionW500Rounded: ImageVector? = null
